var _excluded = ["children", "color", "contrast", "intent", "size"];
var _templateObject;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import styled from '@emotion/styled';
import React from 'react';
import { getIconColor, getIconIntent, getIconSize, ICON_COLORS, ICON_COLORS_SHADES } from "../utils";
var calculateIconColor = function calculateIconColor(_ref) {
  var color = _ref.color,
    intent = _ref.intent,
    shade = _ref.shade,
    _ref$contrast = _ref.contrast,
    contrast = _ref$contrast === void 0 ? 'mid' : _ref$contrast;
  if (intent || contrast === 'inverted') {
    return getIconIntent(intent, contrast);
  } else if (color || shade) {
    if (!ICON_COLORS.includes(color) || !ICON_COLORS_SHADES.includes(shade)) {
      return 'black';
    }
    return getIconColor(color, shade);
  }
  return 'currentColor';
};
export var StyledSvgIcon = styled('svg', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['color', 'contrast', 'intent', 'shade'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  fill: ", ";\n  flex-shrink: 0;\n  height: ", ";\n  width: ", ";\n"])), function (_ref2) {
  var color = _ref2.color,
    intent = _ref2.intent,
    shade = _ref2.shade,
    _ref2$contrast = _ref2.contrast,
    contrast = _ref2$contrast === void 0 ? 'mid' : _ref2$contrast;
  return calculateIconColor({
    color: color,
    intent: intent,
    shade: shade,
    contrast: contrast
  });
}, function (_ref3) {
  var color = _ref3.color,
    intent = _ref3.intent,
    shade = _ref3.shade,
    _ref3$contrast = _ref3.contrast,
    contrast = _ref3$contrast === void 0 ? 'mid' : _ref3$contrast;
  return calculateIconColor({
    color: color,
    intent: intent,
    shade: shade,
    contrast: contrast
  });
}, function (_ref4) {
  var size = _ref4.size;
  return getIconSize(size);
}, function (_ref5) {
  var size = _ref5.size;
  return getIconSize(size);
});
export var SvgIcon = function SvgIcon(_ref6) {
  var children = _ref6.children,
    _color = _ref6.color,
    _ref6$contrast = _ref6.contrast,
    contrast = _ref6$contrast === void 0 ? 'mid' : _ref6$contrast,
    intent = _ref6.intent,
    size = _ref6.size,
    otherProps = _objectWithoutProperties(_ref6, _excluded);
  var colorSplit = (_color !== null && _color !== void 0 ? _color : '').split('.');
  return /*#__PURE__*/React.createElement(StyledSvgIcon, {
    "aria-hidden": otherProps['aria-label'] ? undefined : true,
    "aria-label": otherProps['aria-label'],
    color: intent ? undefined : colorSplit[0],
    contrast: contrast,
    "data-icon-color": intent ? intent : colorSplit[0],
    "data-icon-contrast": contrast,
    "data-icon-variant": otherProps['data-icon-variant'],
    "data-testid": otherProps['data-testid'],
    intent: intent,
    role: "img",
    shade: intent ? undefined : colorSplit[1],
    size: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, children);
};